import { Spinner, Flex } from '@goodrx/matisse';
import React, { useEffect } from 'react';
import DocumentTitle from 'app/components/core/document-title';
import { useSynapse } from 'app/lib/synaptik';
import { useHistory, useParams } from 'react-router-dom';
import { ReactRouterParams } from 'app/types/ReactRouterParams';

export const VerifyEmail: React.FC = () => {
  const [verifyEmail] = useSynapse(({ user }) => [user.verifyEmail]);
  const history = useHistory();
  const params = useParams<ReactRouterParams>();

  useEffect(() => {
    const triggerEmailValidation = async () => {
      const { token } = params;

      if (token) {
        try {
          await verifyEmail(token);
        } catch {
          // empty
        }
      }
      history.push('/account');
    };

    triggerEmailValidation();
  }, []);

  return (
    <Flex style={{ height: '100%' }} flexDirection="column" justifyContent="center" alignItems="center">
      <DocumentTitle titleKey="VerifyEmail" />
      <Spinner />
      <p>Verifying Email</p>
    </Flex>
  );
};
